import React from 'react';

/**
 * The per-card clear (✕) button all three filter renderers share — one definition so the drawer's
 * cards cannot drift apart. A fixed 2.75rem square, matching the 44px inputs it sits beside
 * (asymmetric padding previously rendered it as a rectangle).
 */
export const CLEAR_FILTER_BUTTON_STYLE: React.CSSProperties = {
    marginTop: 0,
    border: '1px solid #E7E7E7',
    color: '#4D4D4D',
    fontSize: '0.875rem',
    height: '2.75rem',
    width: '2.75rem',
    minWidth: '2.75rem',
    padding: 0,
    flexShrink: 0,
};
